import { createFileRoute } from '@tanstack/react-router'

import { BOILER_ROOM_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { technicalRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Vue technique de la chaufferie. Gardes, search et préchargements sont communs aux catégories de
// synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/boiler-room/technical/')(technicalRouteOptions(BOILER_ROOM_DOMAIN))
